
import { useContext, useState } from 'react'
import CheckBoxItem from '../dashboardComponents/CheckBoxItem'
import FormButton from '../dashboardComponents/FormButton';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import { AppContext } from '../../../contextApi/ContextApi';

export default function SetThemeForm({website}) {
    const { setToastMessage, messagesOptions } = useContext(AppContext);
    const {handleChangeTheme, themeFlag, primaryFlag, setPrimaryFlag, secondaryFlag, setSecondaryFlag, accentFlag, setAccentFlag} = useContext(DashboardContext);
    const [primary,setPrimary] = useState(website?.settings?.theme?.primary_color);
    const [secondary,setSecondary] = useState(website?.settings?.theme?.secondary_color);
    const [accent,setAccent] = useState(website?.settings?.theme?.accent_color);

    return (
        <div className='dashboardCheckboxForm'>
            <h2>הגדרת צבעי הנושא של האתר</h2>
            <CheckBoxItem radioLabel={"שנה צבע בסיס"} radioAction={()=>{setPrimaryFlag(!primaryFlag)}} hasFlag={true} flag={primaryFlag} preValue={primary} subType={"color"} subLabel={"בחר צבע:"} subAction={(e)=>{setPrimary(e.target.value)}} desc={"הגדר את הצבע הראשי של האתר שלך"}/>
            <CheckBoxItem radioLabel={"שנה צבע משנה"} radioAction={()=>{setSecondaryFlag(!secondaryFlag)}} hasFlag={true} flag={secondaryFlag} preValue={secondary} subType={"color"} subLabel={"בחר צבע:"} subAction={(e)=>{setSecondary(e.target.value)}} desc={"הגדר את הצבע המשני של האתר שלך"}/>
            <CheckBoxItem radioLabel={"שנה צבע טקסט"} radioAction={()=>{setAccentFlag(!accentFlag)}} hasFlag={true} flag={accentFlag} preValue={accent} subType={"color"} subLabel={"בחר צבע:"} subAction={(e)=>{setAccent(e.target.value)}} desc={"הגדר את הצבע השולי של האתר שלך"}/>
            <FormButton disabled={themeFlag} website={website} text={"שמור"} action={()=>{handleChangeTheme(website, primary, secondary, accent, setToastMessage, messagesOptions )}}/>
        </div>
    )
}
